module.exports = __webpack_public_path__ + "img/banner-prize.148febd0.jpg";